<template>
  <div class="shop_foot">
    <div class="width_center_1200">
      <div class="foot_top">
        <div class="cont">
          <ul v-for="(item, index) in list" :key="index">
            <li class="name">{{ item.title }}</li>
            <li v-for="(v, k) in item.items" :key="k">
              <router-link :to="{ path: `/parse?id=${v.id}` }">{{ v.title }}</router-link>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="qrcode">
            <img src="../../assets/images/facebook.png" alt="facebook" />
            <img src="../../assets/images/mall_qrcode.png" alt="Mall" />
          </div>
          <p>{{ lang.text1 }}</p>
          <p>{{ lang.text2 }}</p>
        </div>
      </div>
      <div class="foot_copyright">
        <ul>
          <li v-for="item in bottomList" :key="item.id">
            <router-link :to="{ path: `/parse?id=${item.id}` }">{{ item.title }}</router-link>
          </li>
        </ul>
        <p>
          {{ lang.text3 }}
          <a href="https://beian.miit.gov.cn/" target="_blank">{{ lang.link }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { gethelpdoclist, getbottomdoclist } from '@/api/home'
export default {
  data() {
    return {
      list: [],
      bottomList: []
    }
  },
  watch: {},
  computed: {
    lang() {
      return this.$t('public_footer')
    }
  },
  methods: {
    getInfo() {
      gethelpdoclist().then(({ data }) => {
        this.list = data
        sessionStorage.setItem('helpDoc', JSON.stringify(data))
      })
      getbottomdoclist().then(({ data }) => {
        this.bottomList = data
        sessionStorage.setItem('bottomDoc', JSON.stringify(data))
      })
    }
  },
  created() {
    if (sessionStorage.getItem('helpDoc')) {
      this.list = JSON.parse(sessionStorage.getItem('helpDoc'))
      this.bottomList = JSON.parse(sessionStorage.getItem('bottomDoc'))
      return
    }
    this.getInfo()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.shop_foot {
  background: #fff;
}

.foot_top {
  padding: 30px 0;
  overflow: hidden;
  .cont {
    float: left;
    ul {
      float: left;
      width: 86px;
      margin-right: 90px;
      li {
        font-size: 12px;
        color: #4f4f4f;
        margin-bottom: 8px;
        &.name {
          font-size: 14px;
          color: #000000;
          margin-bottom: 12px;
        }
      }
    }
  }
  .right {
    float: right;
    margin-right: 48px;
    .qrcode {
      img {
        width: 80px;
        height: 80px;
      }
    }
    p {
      color: #4f4f4f;
      line-height: 24px;
      font-size: 12px;
      padding-left: 5px;
    }
  }
}

.foot_copyright {
  text-align: center;
  clear: both;
  color: #4f4f4f;
  font-size: 12px;
  padding-bottom: 40px;
  border-top: 1px solid #fae5dc;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
    li {
      margin: 0 8px;
    }
  }
}
a:hover {
  color: #d78722;
}
</style>